import { useEffect, useMemo } from 'react';
import { map } from './core/MapView';
import { openAssistant, useAssistantState } from '../common/assistant/assistant';
import '../common/assistant/assistant.css';

// Talk and chat buttons in the map's control column, drawn like the zoom
// buttons (the same way as the notification bell, MapNotification).
class AssistantControl {
  onAdd() {
    this.mic = document.createElement('button');
    this.mic.type = 'button';
    this.mic.title = 'Talk to the assistant';
    this.mic.setAttribute('aria-label', 'Talk to the assistant');
    this.mic.onclick = () => openAssistant('voice');

    this.chat = document.createElement('button');
    this.chat.type = 'button';
    this.chat.title = 'Chat with the assistant';
    this.chat.setAttribute('aria-label', 'Chat with the assistant');
    this.chat.onclick = () => openAssistant('text');

    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl-group maplibregl-ctrl';
    this.container.appendChild(this.mic);
    this.container.appendChild(this.chat);
    this.setActive(null);
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
  }

  setActive(kind) {
    if (!this.mic) return;
    this.mic.className = `maplibregl-ctrl-icon assistant-ctrl-mic${kind === 'voice' ? ' assistant-ctrl-active' : ''}`;
    this.chat.className = `maplibregl-ctrl-icon assistant-ctrl-chat${kind === 'text' ? ' assistant-ctrl-active' : ''}`;
  }
}

const MapAssistant = () => {
  const control = useMemo(() => new AssistantControl(), []);
  const { active, kind } = useAssistantState();

  useEffect(() => {
    map.addControl(control);
    return () => map.removeControl(control);
  }, [control]);

  useEffect(() => {
    control.setActive(active ? kind : null);
  }, [control, active, kind]);

  return null;
};

export default MapAssistant;
